var map = {
	"./about-us.svg": 759,
	"./betting-icon.svg": 760,
	"./bonus.svg": 761,
	"./coin.svg": 762,
	"./contact-us.svg": 763,
	"./download-app.svg": 764,
	"./edit-btn.svg": 765,
	"./feedback.svg": 766,
	"./global.svg": 767,
	"./info-centre.svg": 768,
	"./info-centre.webp": 1637,
	"./instant-rebate.svg": 769,
	"./mall-icon.svg": 770,
	"./message.svg": 771,
	"./personal-info-edit.svg": 772,
	"./r77-coin.svg": 773,
	"./r77-rewards.svg": 774,
	"./redemption-icon.svg": 775,
	"./referral.svg": 776,
	"./resp-gaming.svg": 777,
	"./security.svg": 778,
	"./transaction-icon.svg": 779,
	"./vip-icon.svg": 780,
	"./wallet-icon.svg": 781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 758;